import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BgImage } from '~/components/atoms/bg-element/BgImage';
import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import { Link } from '~/components/ui/link';
import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { PATH } from '~/constants/route-path';
import {
  StyledBigCard,
  StyledBigCardIconWrapper,
  StyledBigCardImage,
  StyledBigCardsContainer,
  StyledContainer,
  StyledLayout,
  StyledSmallCard,
  StyledSmallCardIconWrapper,
  StyledSmallCardsContainer,
} from '~/pages/QrsOn/styled';
import { COLORS } from '~/styles/colors';

import menuImage from './assets/big-cards/menu.png';
import menuIcon from './assets/small-cards/menu.png';

const SMALL_CARDS = [...new Array(30)].map(() => ({
  id: 'menu',
  icon: menuIcon,
  name: 'Menu',
}));

const BIG_CARDS = [...new Array(30)].map(() => ({
  id: 'menu',
  image: menuImage,
  icon: menuIcon,
  name: 'Menu',
}));

export default function QrsOn() {
  const navigate = useNavigate();
  const [isShowedMore, setIsShowedMore] = useState(false);
  const ref = useRef(null);

  const onCardClick = (id) => {
    navigate(PATH.UNAUTH.QRS_ON_DETAIL(id));
  };

  return (
    <StyledLayout>
      <HeaderPublic />

      <BgImage.circlesFilledBigSize $top={50} $left={-230} $size={478} />

      <StyledContainer>
        <Title type={TITLE_TYPE.h2} color={COLORS.textMain} center mt={100}>
          Our QRs in the wild.
        </Title>
        <TextOld color={COLORS.grey400} fontWeight={400} textAlign="center">
          Discover how to use QR codes to boost your marketing strategy.
        </TextOld>
        <div
          style={{
            height: isShowedMore ? `${ref.current?.clientHeight || 0}px` : '190px',
            overflow: 'hidden',
            transition: 'height 0.4s ease',
          }}
        >
          <StyledSmallCardsContainer ref={ref}>
            {SMALL_CARDS.map(({ id, icon, name }, i) => (
              <StyledSmallCard key={i} onClick={() => onCardClick(id)}>
                <StyledSmallCardIconWrapper>
                  <img src={icon} />
                </StyledSmallCardIconWrapper>
                <TextOld color={COLORS.grey400} fontSize={15}>
                  {name}
                </TextOld>
              </StyledSmallCard>
            ))}
          </StyledSmallCardsContainer>
        </div>
        <TextOld
          color={COLORS.textMain}
          fontSize={15}
          mt={20}
          mb={40}
          textAlign={'center'}
          textDecoration={'underline'}
        >
          <div style={{ cursor: 'pointer' }} onClick={() => setIsShowedMore(!isShowedMore)}>
            {isShowedMore ? 'Show less' : 'Show more'}
          </div>
        </TextOld>
        <StyledBigCardsContainer>
          {BIG_CARDS.map(({ id, image, icon, name }, i) => (
            <StyledBigCard key={i} onClick={() => onCardClick(id)}>
              <StyledBigCardImage src={image} />
              <div>
                <StyledBigCardIconWrapper>
                  <img src={icon} />
                </StyledBigCardIconWrapper>
                <TextOld color={COLORS.grey400} fontSize={15} pt={14} pb={57}>
                  {name}
                </TextOld>
                <Link>More info</Link>
              </div>
            </StyledBigCard>
          ))}
        </StyledBigCardsContainer>
      </StyledContainer>
      <FooterPublic />
    </StyledLayout>
  );
}
